import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

/**
 * Generated class for the DayCalendarComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: "plusminus",
  templateUrl: "plusminus.component.html",
  styleUrls: ["./plusminus.component.scss"]
})
export class PlusMinusComponent implements OnInit {
  _metric: string;
  _quantity = 0;
  _step = 1;
  _max: number;
  _min = 1;
  _disabled = false;

  @Input()
  metric: string;

  @Input()
  disabled = false;

  @Input()
  disabledMessage: string;

  get step(): number {
    return this._step;
  }
  @Input("step")
  set step(value: number) {
    this._step = typeof value == "number" ? value : parseFloat(value);
    if (!this._min) this._min = this._step;
  }

  get quantity(): number {
    return this._quantity;
  }
  @Input("quantity")
  set quantity(value: number) {
    this._quantity = typeof value == "number" ? value : parseFloat(value);
  }

  get max(): number {
    return this._max;
  }
  @Input("max")
  set max(value: number) {
    this._max = typeof value == "number" ? value : parseFloat(value);
  }

  get min(): number {
    return this._min;
  }
  @Input("min")
  set min(value: number) {
    this._min = typeof value == "number" ? value : parseFloat(value);
  }

  @Output() quantityChanged = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  onPlus(event) {
    event.stopPropagation();
    if (this._quantity == 0) {
      this._quantity = this._min || 1;
    } else if (!!this._max && this._quantity + this._step >= this._max) {
      this._quantity = this._max;
    } else {
      this._quantity += this._step || 1;
    }
    this.quantityChanged.emit(this._quantity);
  }

  onMinus(event) {
    event.stopPropagation();
    if (!this._min) {
      this._min = 1;
    }
    if (this._min == this._quantity) {
      this._quantity = 0;
    } else if (this._quantity - this._step <= this._min) {
      this._quantity = this._min;
    } else {
      this._quantity -= this._step || 1;
    }
    this.quantityChanged.emit(this._quantity);
  }
}
